<template>
  <div>
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.cusromerReturns'), $t('text.list')]">
        <el-button
          v-if="!Permit.isFreeEdition()"
          type="success"
          size="mini"
          @click="$router.push('/normal/to-do-lists/customer-returns/new')"
        >
          + {{ $t("text.create") }}
        </el-button>
      </breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.keyword"
            :placeholder="$t('placeholder.serialNoCustomerNamePhone')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.tracking"
            :placeholder="
              $t('placeholder.deliverySerialNoTrackingReturnTracking')
            "
            style="width: 220px"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="createdAt"
            :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
            :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="receivesTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <!-- <thumbnail v-if="row.order != null" :images="row.order.images" /> -->
            <thumbnail :images="row.images" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="orderSerialNo"
          :title="$t('text.serialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <span v-if="row.order == null">
              {{ row.orderSerialNo }}
            </span>
            <span v-else class="blue" @click="showRecord(row)">
              {{ row.orderSerialNo }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="50"
        />

        <vxe-table-column
          field="remark"
          :title="$t('returnBack.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <thumbnail-text
              v-if="row.voucher != null"
              :srcs="row.voucher"
              :text="'凭证'"
            />
            <div>
              <raw-html-limit-number
                :content="row.remark"
                :number="8"
                type="richText"
              />
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="haveGood"
          :title="$t('returnBack.haveGood')"
          min-width="70"
        >
          <template v-slot="{ row }">
            <span :class="row.haveGood == true ? 'green' : 'red'">
              {{ $t("boolean." + row.haveGood) }}
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerName"
          :title="$t('bargain.customerName')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div class="font10" v-if="row.customerPhone != null">
              {{ $t("bargain.customerPhone") }}:{{ row.customerPhone }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="returnTracking"
          :title="$t('returnBack.returnTracking')"
          min-width="90"
        >
          <template v-slot="{ row }">
            <i
              slot="reference"
              class="el-icon-edit fl"
              @click="editReturnTracking(row, rowIndex)"
            />{{ row.returnTracking }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="deliverySerialNo"
          :title="$t('returnBack.deliverySerialNo')"
          min-width="90"
        />
        <vxe-table-column
          field="deliceryTracking"
          :title="$t('returnBack.deliceryTracking')"
          min-width="90"
        />

        <vxe-table-column :title="$t('returnBack.receiveAt')" min-width="100">
          <template v-slot="{ row }">
            {{ row.receiverName }}
            <div class="font10">{{ row.receiveAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column :title="$t('rework.finishAt')" min-width="100">
          <template v-slot="{ row }">
            {{ row.finisher }}
            <div class="font10">{{ row.finishAt }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.ownerName }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          min-width="110"
        />
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="100"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="Permit.isFreeEdition() && row.receiveAt == null"
              type="text"
              size="mini"
              @click="receive(row)"
              >{{ $t("action.receive") }}</el-button
            >
            <el-button
              v-if="row.entityId == null && row.receiveAt == null"
              type="text"
              size="mini"
              @click="deleteRow(row)"
              >{{ $t("text.delete") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- ======== -->
    <drawer
      :title="$t('text.view', [$t('menu.bargains')])"
      :visible.sync="show"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order :id="currentRowId" />
    </drawer>
    <!-- 编辑退货跟踪号 -->
    <el-dialog
      :title="$t('text.edit')"
      :close-on-click-modal="false"
      :visible.sync="editReturnTrackingDF"
      width="30%"
    >
      <el-form
        ref="editReturnTrackingObjForm"
        :model="editReturnTrackingObj"
        label-width="90px"
      >
        <el-form-item
          :label="$t('returnBack.returnTracking')"
          :prop="'returnTracking'"
        >
          <el-input
            size="small"
            v-model.trim="editReturnTrackingObj.returnTracking"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editReturnTrackingDoing"
          size="small"
          @click="editReturnTrackingSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editReturnTrackingDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import DateRange from "@/components/DateRange";
import Thumbnail from "@/components/Thumbnail";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import ThumbnailText from "@/components/ThumbnailText";
import ReturnBack from "@/api/returnBack.js";
import ShowOrder from "@/views/oms/bargains/showOrder.vue";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    DateRange,
    Thumbnail,
    RawHtmlLimitNumber,
    ThumbnailText,
    ShowOrder,
  },

  data() {
    return {
      Util: Util,
      sorter: {
        sortBy: "returnBacks_id",
        sortIndicator: "desc",
      },
      narrows: [
        [
          {
            label: this.$t("returnBack.returnBackInfo"),
            items: [
              {
                label: this.$t("reworkInfos.yes"),
                key: "yes",
                condition: { finish: "yes" },
              },
              {
                label: this.$t("reworkInfos.no"),
                key: "no",
                condition: { finish: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        keyword: null,
        profuctNo: null,
        tracking: null,
      },
      //
      currentRowId: null,
      show: false,
      //编辑退货跟踪号
      row: null,
      editReturnTrackingObj: {
        returnTracking: null,
      },
      editReturnTrackingDoing: false,
      editReturnTrackingDF: false,
    };
  },
  created() {
    const self = this;
  },
  methods: {
    // 删除
    deleteRow(row) {
      const self = this;
      if (confirm(this.$t("prompt.confirmDelete"))) {
        ReturnBack.delete(row.id).then(function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.delSuccess"),
              type: "success",
            });
            self.loadData();
            self.$eventHub.$emit("returnBackDelete");
          } else {
            self.sysError();
          }
        });
      }
    },
    // 编辑退货跟踪号
    editReturnTracking(row) {
      const self = this;
      self.row = row;
      self.editReturnTrackingObj.returnTracking = row.returnTracking;
      self.editReturnTrackingDoing = false;
      self.editReturnTrackingDF = true;
    },

    editReturnTrackingSubmit() {
      const self = this;
      self.editReturnTrackingDoing = true;
      ReturnBack.updateReturnTracking(
        self.row.id,
        self.editReturnTrackingObj
      ).then(function (res) {
        self.editReturnTrackingDoing = false;
        self.editReturnTrackingDF = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.editSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError();
        }
      });
    },
    //
    receive(row) {
      const self = this;
      ReturnBack.receiveFinish(row.id).then(function (res) {
        if (res.status == 200) {
          self.$message({
            message: self.$t("prompt.receiveSuccess"),
            type: "success",
          });
          self.loadData();
        } else {
          self.sysError;
        }
      });
    },
    showRecord(row) {
      this.currentRowId = row.order.id;
      this.show = true;
    },
    //
    dataProvider(params) {
      return ReturnBack.search(params);
    },
  },
};
</script>
